import { render, staticRenderFns } from "./phone2.vue?vue&type=template&id=289a8f21&scoped=true"
import script from "./phone2.vue?vue&type=script&lang=js"
export * from "./phone2.vue?vue&type=script&lang=js"
import style0 from "./phone2.vue?vue&type=style&index=0&id=289a8f21&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289a8f21",
  null
  
)

export default component.exports